const UserDetail = {
  // Set
  setUserID(val) {
    localStorage.setItem("user-id", JSON.stringify(val));
  },
  setUserRole(val) {
    localStorage.setItem("user-permissions", JSON.stringify(val));
  },
  setUserQuota(val) {
    localStorage.setItem("user-free-profile-quota", JSON.stringify(val));
  },
  setUserIsDeleted(val) {
    localStorage.setItem("user-is-deleted", JSON.stringify(val));
  },
  setUserName(val) {
    localStorage.setItem("user-name", JSON.stringify(val));
  },
  setUserEmail(val) {
    localStorage.setItem("user-email", JSON.stringify(val));
  },
  setUserFreeQuota(val) {
    localStorage.setItem("user-storage-quota", val);
  },
  // Get
  getUserID() {
    return JSON.parse(localStorage.getItem("user-id"));
  },
  getUserRole() {
    return JSON.parse(localStorage.getItem("user-permissions"));
  },
  getUserQuota() {
    if (JSON.parse(localStorage.getItem("user-free-profile-quota")))
      return JSON.parse(localStorage.getItem("user-free-profile-quota"))
    if (localStorage.getItem("user-free-profile-quota"))
      return localStorage.getItem("user-free-profile-quota")
    return false;
  },
  getUserIsDeleted() {
    return JSON.parse(localStorage.getItem("user-is-deleted"));
  },
  getUserName() {
    return JSON.parse(localStorage.getItem("user-name"));
  },
  getUserEmail() {
    return JSON.parse(localStorage.getItem("user-email"));
  },
};

export { UserDetail };
